import { NgModule } from '@angular/core';
import {
  CybNavMenuComponent,
  CybNavMenuItemDirective
} from './navigation.component';

@NgModule({
  declarations: [
    CybNavMenuComponent, CybNavMenuItemDirective
  ],
  exports: [
    CybNavMenuComponent, CybNavMenuItemDirective
  ]
})

export class CybNavigationModule { }
